import * as A from 'constants/actions'
import { showNotification } from './ux'
import store from '../store'
import { ApiService } from 'services'

export const setSurveySubmission = (payload: any) => ({
  type: A.SET_SURVEY_SUBMISSION,
  payload: payload,
})
